import Vue from 'vue'
import store from '../store'
let config = {
  auth: require('./driver'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x'),
  // 定义登录接口，并且在登录的时候自动获取用户信息
  loginData: {
    url: '/auth/login',
    method: 'POST',
    rememberMe: true,
    fetchUser: true
  },
  // 定义登出接口，目前没有对服务器发起请求
  logoutData: {
    url: '/auth/logout',
    method: 'PUT',
    makeRequest: false,
    redirect: '/login'
  },
  authRedirect: {
    path: '/login'
  },
  // 定义获取用户信息的接口
  fetchData: {
    url: 'uaa/api/organization-user/information',
    method: 'GET',
    enabled: true,
    params: {

    }
  },
  refreshData: { enabled: false },
  // 自定义用户数据解析
  parseUserData: function (data) {
    // data.id = data.droneUser.id
    data.viewPositions = ['LAB']//getTargetView(data.viewPositions)
    // 设定默认当前视角
    if (!store.state.saasConfig.focusView) {
      store.commit('updateFocusView', data.viewPositions[0])
    }
    getContractInfo()
    return data
  },
  check: function () {
    let userInfo = this.user()
    // console.log('userInfo', userInfo)
    if (JSON.stringify(userInfo) === '{}') {
      return false
    } else if (userInfo && !userInfo.permissions.includes('PERM_CONSOLE_OPERATE')) {
      Vue.prototype.$message.warning('您不具备访问该后台的权限')
      // this.redirect()
      return false
    }
    return true
  }
}
function getTargetView (views) {
  if (views.includes('LAB')) {
    return ['LAB']
  }
  if (views.includes('DISTRIBUTION')) {
    return ['DISTRIBUTION']
  }
  return views
}
async function getContractInfo () {
  // 获取该租户是否开启合同功能
  let openContract = await store.dispatch('LocalIsEnabled')
  // 更新开启合同信息
  store.commit('updateContractSwitch', openContract)
}
export default config
